import styled, { css } from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { OutlineButton, PrimaryButton } from '../../../components/ButtonStyles';

export const MerchantReferralOptionDiv = styled.div`
  border: 1px solid ${props => props.theme.mercury};
  padding: 0rem 2.6rem 4rem;
  ${props =>
    props.largePaddingBottom &&
    css`
      padding: 0rem 2.6rem 8rem 2.6rem;
    `}
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    max-width: 425px;
    margin: 0 auto 15px;
  }
  @media screen and (min-width: 768px) {
    padding: 0rem 2.3rem 4rem;
    margin: 0 auto 25px;
    ${props =>
      props.largePaddingBottom &&
      css`
        padding: 0rem 2.3rem 8rem 2.3rem;
      `}
  }
  @media screen and (min-width: 1024px) {
    > div {
      max-width: 800px;
    }
    padding: 0rem 4rem 4rem;
    ${props =>
      props.largePaddingBottom &&
      css`
        padding: 0rem 4rem 10rem 4rem;
      `}
  }
  @media screen and (min-width: 1440px) {
    > div {
      max-width: 900px;
    }
  }
  @media screen and (max-width: 767px) {
    ${PrimaryButton} {
      margin: 0 auto;
    }
  }
  ${PrimaryButton} {
    font-weight: 600;
  }
`;

export const MerchantReferralOptionHeader = styled.div`
  @media screen and (max-width: 767px) {
    text-align: center;
  }
  h5 {
    line-height: 1.7rem;
    letter-spacing: 0.03em;
  }
`;

export const MerchantReferralContentDiv = styled.div`
  h5 {
    line-height: 1.7rem;
    letter-spacing: 0.03em;
  }
  @media screen and (max-width: 767px) {
    text-align: center;
  }
`;

export const OptionHeaderDiv = styled.div`
  background-color: ${props => props.theme.blue};
  display: inline-flex;
  padding: 6px 15px;
  margin: 0px 0px 30px 0px;
  && {
    h5 {
      color: white;
      font-size: 12px;
      margin-bottom: 0px;
    }
  }
  @media screen and (max-width: 767px) {
    margin: 0 auto 30px;
  }
`;

export const RegistrationMethodsDiv = styled.div`
  margin-bottom: 23px;
  display: flex;
  justify-content: space-between;
  @media screen and (min-width: 768px) {
    margin-bottom: 50px;
  }
  margin-top: 15px;
`;

export const BoxNavLink = styled(NavLink)`
  border: 1px solid ${props => props.theme.mercury};
  /* border: 1px solid transparent; */
  color: black;
  width: 32%;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  h5,
  p {
    text-align: center;
  }
  h5 {
    font-weight: 500;
    line-height: 1.25;
    text-transform: capitalize;
  }
  &.active {
    h5 {
      color: ${props => props.theme.blue};
    }
    border: 1px solid ${props => props.theme.blue};
  }
  &:hover {
    border: 1px solid ${props => props.theme.blue};
  }
  @media screen and (max-width: 767px) {
    height: 70px;
    justify-content: center;
    p {
      display: none;
    }
  }
  @media screen and (min-width: 768px) {
    h5 {
      margin-bottom: 11px;
    }
    padding: 3.5rem 2.5rem 2.5rem 2.5rem;
  }
  @media screen and (min-width: 1024px) {
    padding: 3rem 2rem;
  }
`;

export const SmallOutlineButton = styled(OutlineButton)`
  padding: 7px 15px;
  width: unset;
  max-width: 180px;
  @media screen and (max-width: 767px) {
    margin: 0 auto;
  }
`;

export const MerchantRegistrationOptionDiv = styled.div`
  p {
    margin-bottom: 12px;
  }
  label {
    ${props => props.theme.fontStackHeader};
    font-weight: 500;
    font-size: 1.3rem;
    display: inline-block;
    margin-bottom: 8px;
  }
  h5 {
    margin-bottom: 16px;
  }
  > div {
    &:not(:last-child) {
      margin-bottom: 30px;
      @media screen and (max-width: 767px) {
        margin-top: 16px;
      }
    }
  }
  ${props =>
    props.multiColumn &&
    css`
      @media screen and (min-width: 768px) {
        margin-top: 17px;
        display: flex;
        justify-content: space-between;
        > div {
          width: 48%;
        }
      }
    `}
`;
